var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergised(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3724_14183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2167 3.66665L10.9333 7.89166C10.7083 8.32499 10.9083 8.84999 11.3583 9.00832L14.4833 10.1C14.9917 10.2833 15.1667 10.9417 14.8083 11.3583L9.60832 17.3583C9.32498 17.6916 8.80832 17.4333 8.85832 17.0167L9.43332 12.8917C9.48332 12.5167 9.27498 12.175 8.93332 12.05L5.50832 10.7917C5.07498 10.6417 4.87499 10.125 5.08332 9.7L8.43331 2.94166C8.55831 2.68332 8.81664 2.50833 9.10831 2.50833H12.525C13.125 2.525 13.4831 3.16589 13.2081 3.68255L13.2167 3.66665Z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3724_14183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergised);
export default __webpack_public_path__ + "static/media/energised.4d24798ff1de055595729988865f0852.svg";
export { ForwardRef as ReactComponent };